import React, { useState, useEffect } from "react";
import Intro from "../components/Intro";
import Project from "../components/Projects/Project";

import Contact from "../components/contact/Contact";
import About from "../components/about/About";
import Services from "../components/services/Services";
import FAQs from "../components/faqs/FAQs";
import Testimonial from "../components/testimonials/Testimonials";

const HomePage = () => {
  return (
    <div style={{padding:"5rem 0",backgroundColor:"var(--z)"}}>
     <Intro/>
     <About/>
   <Project/>
   <Services/>
   <Testimonial/>
   <FAQs/>
   <Contact/>

    </div>
  );
};

export default HomePage;
